import React from 'react';
import { Accordion } from './ui/Accordion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  return <section className="py-12 px-4 text-white" data-id="element-13">
      <div className="max-w-lg mx-auto bg-teal-900/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-teal-700/40" data-id="element-14">
        <div className="flex items-center justify-center gap-3 mb-6" data-id="element-15">
          <Gift className="w-8 h-8 text-yellow-400" data-id="element-16" />
          <h2 className="text-2xl md:text-3xl font-bold text-center" data-id="element-17">
            Además de regalo:
          </h2>
        </div>

        <p className="text-center text-teal-100 mb-8 font-medium" data-id="element-18">
          Llevate este bono exclusivo{' '}
          <span className="text-yellow-400 font-bold uppercase" data-id="element-19">
            GRATIS por el día de hoy
          </span>
        </p>

        <div className="bg-white rounded-xl p-1 mb-8 shadow-2xl" data-id="element-20">
          <Accordion title="🎁 Modelo de Comunicación para Aislamiento Preventivo" defaultOpen={true} data-id="element-21">
            <div className="flex flex-col md:flex-row gap-4 items-center" data-id="element-22">
              <div className="w-24 h-24 bg-teal-50 rounded-lg flex items-center justify-center flex-shrink-0 border border-teal-100" data-id="element-23">
                <Gift className="w-10 h-10 text-teal-600" data-id="element-24" />
              </div>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-25">
                Plantilla legal y formal lista para usar en caso de que
                necesites comunicar a un empleado del sector salud sobre un
                aislamiento preventivo por protocolo. Redactada bajo normativas
                vigentes para evitar conflictos legales.
              </p>
            </div>
          </Accordion>
        </div>
      </div>
    </section>;
}